import "./src/styles/global.css"

// disable prefetch (it will still prefetch onHover Link, but not when onScreen)
export const disableCorePrefetching = () => true

